import { EllipsedText, Loading, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useStyles } from '../../hooks/useStyles';
import { isVehicleLikeType } from '../../utils/assets';

function SearchableAssetItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { theme } = useStyles();
  const asset = data.items[index];

  const label = isVehicleLikeType(asset.assetType)
    ? `${asset.label ?? 'Sin etiqueta'} / ${asset.vehicle?.brand?.name ?? ''} ${asset.vehicle?.subBrand?.name ?? ''} ${
        asset.vehicle?.licensePlate ?? ''
      }`
    : `${asset.label ?? ''}`;

  const description = asset.device ? `Dispositivo asignado: ${asset.device.ident}` : 'Sin dispositivo';

  return (
    <span style={style as CSSProperties}>
      {data.isLoaded(index) ? (
        <ListItem
          overrides={{
            Content: {
              style: {
                marginLeft: 0,
                paddingLeft: theme.sizing.scale600,
              },
            },
          }}
        >
          <ListItemLabel description={description}>
            <EllipsedText inline>{label}</EllipsedText>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(SearchableAssetItem);
